/* __next_internal_client_entry_do_not_use__ PromotedBadge auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled, { css } from "styled-components";
export var PromotedBadge = function(param) {
    var noPadding = param.noPadding;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var viewport = useViewport();
    if (viewport.isTabletAndBelow) {
        return /*#__PURE__*/ _jsx(BadgeContent, {
            noPadding: noPadding
        });
    }
    return /*#__PURE__*/ _jsx(StyledTooltip, {
        position: "bottom",
        targetNode: /*#__PURE__*/ _jsx(BadgeContent, {
            noPadding: noPadding
        }),
        contents: [
            {
                title: undefined,
                body: strictLocalize({
                    id: "Zq4Bu1",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "You\u2019re seeing this promoted product based on its relevance to your search query or browsing history on Faire."
                        }
                    ]
                })
            }
        ]
    });
};
var BadgeContent = function(param) {
    var noPadding = param.noPadding;
    return /*#__PURE__*/ _jsx(StyledPromotedBadge, {
        variant: "labelSansRegular",
        color: Core.text.subdued,
        $noPadding: noPadding,
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "4XFRVk",
            defaultMessage: [
                {
                    type: 0,
                    value: "Promoted"
                }
            ]
        })
    });
};
var StyledTooltip = styled(Tooltip).withConfig({
    componentId: "sc-c6c31d5a-0"
})([
    "width:fit-content;"
]);
var StyledPromotedBadge = styled(Typography).withConfig({
    componentId: "sc-c6c31d5a-1"
})([
    "",
    ""
], function(props) {
    return !props.$noPadding ? css([
        "padding:4px 0;"
    ]) : "";
});
